import { Component, Inject, OnInit } from "@angular/core";
import { Router, Event, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from "@angular/router";

import { UtilityService } from "projects/shared-lib/src/lib/services/utility.service";
import { environment, environment as Test } from "../environments/environment.test";
import { environment as Beta } from "../environments/environment.beta";
import { environment as Prod } from "../environments/environment.prod";

import { initializeLinq, IEnumerable, ArrayEnumerable } from "linq-to-typescript";
import { Global } from "projects/shared-lib/src/lib/_constants/global.variables";
import { DataService } from "projects/shared-lib/src/lib/services/data.service";
import { IUser } from "projects/shared-lib/src/lib/_models/user.model";
import { IStepOption, TourAnchorMatMenuDirective, TourMatMenuModule, TourService } from "ngx-ui-tour-md-menu";
import { IGlobal } from "projects/shared-lib/src/lib/_models/global.model";
import { BehaviorSubject } from "rxjs";
import { SecurityService } from "projects/shared-lib/src/lib/services/security.service";
// import { OKTA_AUTH, OktaAuthStateService } from '@okta/okta-angular';
// import { OktaAuth } from '@okta/okta-auth-js';

declare global {
	interface Array<T> extends IEnumerable<T> {
		concat(items: IEnumerable<T>): IEnumerable<T>;
		concat(...items: Array<ReadonlyArray<T>>): ArrayEnumerable<T>;
		concat(...items: Array<T | ReadonlyArray<T>>): ArrayEnumerable<T>;
	}
	interface Uint8Array extends IEnumerable<number> {}
	interface Uint8ClampedArray extends IEnumerable<number> {}
	interface Uint16Array extends IEnumerable<number> {}
	interface Uint32Array extends IEnumerable<number> {}
	interface Int8Array extends IEnumerable<number> {}
	interface Int16Array extends IEnumerable<number> {}
	interface Int32Array extends IEnumerable<number> {}
	interface Float32Array extends IEnumerable<number> {}
	interface Float64Array extends IEnumerable<number> {}
	interface Map<K, V> extends IEnumerable<[K, V]> {}
	interface Set<T> extends IEnumerable<T> {}
	interface String extends IEnumerable<string> {}
}

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {
	loading = false;
	public global: IGlobal = Global;

	public theme$: BehaviorSubject<string> = new BehaviorSubject<string>(Global.Theme);
	public companyLogo$: BehaviorSubject<any> = new BehaviorSubject<any>(Global.CompanyLogoImage);
	public componentName: string = "app.component.ts (desktop): ";
	private baseUrl: string;
	private isAuthenticated: boolean = false;
	private userIsBeingAuthenticated: boolean = false;
	private userIsBeingProcessed: boolean = false;

	constructor(private router: Router, 
				private utilityService: UtilityService, 
				public dataService: DataService, 
				private securityService: SecurityService, 
				public tourService: TourService,
				
			) 
	{
		initializeLinq();
		this.initializeGlobalVariables();
		var globalObject: IGlobal = Global;
		//console.log("Global = %O", globalObject);

		Global.isMobile = false;

		this.securityService.userIsBeingAuthenticated$.subscribe((authenticationInProgress: boolean) => {
			this.userIsBeingAuthenticated = authenticationInProgress;
		});
		
		this.securityService.userIsBeingProcessed$.subscribe((processing:boolean) => {
			this.userIsBeingProcessed = processing;
		});

		router.events.subscribe((routerEvent: Event) => {
			if (this.router.url != "/authentication" && this.router.url != "/user/authentication" && this.router.url != "/login" && this.router.url != "/logout" && this.router.url != "/login/callback"  && this.router.url != "/" && this.router.url != "/home" && this.router.url != "/layout/user-settings" && localStorage.getItem("currentUser")) {
				this.checkRouterEvent(routerEvent);
				if (Global?.User?.currentUser?.Id != null && !Global.User.isLoggedInAsDifferentUser) {
					var lastVisitedRoute: string = localStorage.getItem("lastVisitedRoute");
					var newlyVisitedRoute: string = this.router.url;
					localStorage.setItem("lastVisitedRoute", this.router.url);
					localStorage.setItem("lastVisitedRouteTitle", Global.CurrentMenuItem);

					if (lastVisitedRoute != newlyVisitedRoute) {
						//-- update SQL Server so we have the last route this user visited if we need to rebuild the local storage, but only if the routes are different.  No need to
						//-- continually update SQL Server with the same route. --Kirk T. Sherer, May 11, 2023.
						var sql: string = "Security.User_UpdateLastVisitedRoute @UserId=" + Global.User.currentUser.Id + ", @LastVisitedRoute='" + this.router.url + "', @LastVisitedRouteTitle='" + Global.CurrentMenuItem + "'";
						this.dataService.SQLActionAsPromise(sql).then((data: any) => {
							console.log("Route logged. URL: " + this.router.url);
						});
					}
				}
			} else {
				this.loading = false;
			}
			// console.log("this.router.url: " + this.router.url + ", loading: " + this.loading);
		});

		//Global.Data.dataServerIsLocal = false; //--only set this to true if you're testing a local version of the webAPI. 

		

		
	}

	initializeGlobalVariables() {
		this.dataService.initializeGlobalVariables("desktop");
		this.appSetupAfterAuthentication();
	}

	async appSetupAfterAuthentication() {
		var service = this;
		var environmentName = document.URL.indexOf("localhost") > 0 || document.URL.indexOf("test") > 0 ? (Global.Application?.Environment?.Name != null ? Global.Application.Environment.Name : "test") : document.URL.indexOf("beta") > 0 ? "beta" : "prod";
		var environmentId = null;
		var version = null;
		switch (environmentName) {
			case "test":
				environmentId = Test.environmentId;
				break;
			case "beta":
				environmentId = Beta.environmentId;
				break;
			case "prod":
				environmentId = Prod.environmentId;
				break;
		}

		Global.Application = {
			Environment: {
				Name: environmentName,
				Id: environmentId,
				Version: version,
        		Database: "prod"
			},
			Type: "desktop"
		};

		
	}

	checkRouterEvent(routerEvent: Event): void {
		if (routerEvent instanceof NavigationStart) {
			this.loading = true;
		} else {
			if (routerEvent instanceof NavigationEnd || routerEvent instanceof NavigationCancel || routerEvent instanceof NavigationError) {
				this.loading = false;
			}
		}
	}

	gm_authFailure() {
		console.error("Google Maps authentication error fired. Please investigate.");
	}

	ngOnInit() {
		var passwordToken = this.utilityService.GetQuerystringParameterByName("pwt");
		if (passwordToken) {
			console.log("passwordToken = " + passwordToken);
			Global.passwordToken = passwordToken;
			console.log("Global.passwordToken = " + Global.passwordToken);
			this.router.navigate(["/forgot-password/" + passwordToken]);
		}
	}
}
